module.exports = __webpack_public_path__ + "static/media/icon_cross-light.e64fc575.svg";